<template>
    <div>
        <tabs-header-mobile
            route-to-name="SupplierProductsEdit"
            title="Вставки"
        />

        <form
            class="product-form product-form-insert supplier-tab"
            @submit.prevent="null"
        >
            <div class="subtitle1 mb-4">Вставки</div>
            <div class="row mb-4">
                <div class="caption col-12 col-md-7">
                    <div class="cabinet-form-group--input-wrap">
                        Вы можете добавить текстовое описание вставок или
                        описать каждую вставку отдельно при помощи специальной
                        формы ниже. Обращаем ваше внимание, что данные из
                        текстового описания не отображаются в фильтрах в
                        каталоге ритейлера.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-12 col-md-6">
                    <div
                        class="cabinet-form-group cabinet-form-group--input-wrap"
                    >
                        <label class="cabinet-form-group__label" for="descr"
                            >Текстовое описание вставок</label
                        >
                        <textarea
                            id="descr"
                            v-model="product.iteminsert"
                            class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable mw-100"
                        ></textarea>
                    </div>
                </div>
            </div>

            <div v-if="!product.inserts.length" class="pt-3 pb-3">
                Без вставок
            </div>

            <div
                v-for="(insert, i) in product.inserts"
                :key="i"
                class="product-form-insert__block"
            >
                <div class="d-flex justify-content-between">
                    <h3 class="h3 product-form__title">
                        Вставка # {{ i + 1 }}
                    </h3>
                    <button
                        type="button"
                        class="cabinet-btn-icon cabinet-btn-icon--default cabinet-btn-icon--small cabinet-btn-icon--trash disabled"
                        @click="removeInsert(i)"
                    ></button>
                </div>

                <div class="row">
                    <div class="col-md-4 order-md-1 product-form-insert__col">
                        <div
                            class="cabinet-form-group"
                            :class="{
                                error:
                                    $v.product.inserts.$each.$iter[i].material
                                        .$dirty &&
                                    $v.product.inserts.$each.$iter[i].material
                                        .$invalid
                            }"
                        >
                            <label class="cabinet-form-group__label"
                                >Материал</label
                            >
                            <select-picker
                                :current-value="insert.material"
                                :options="insertMaterials"
                                key-value="MaterialID"
                                key-title="Name"
                                :classes="['select', 'select--product-form']"
                                :search="true"
                                @onChange="
                                    onInsertSelectPickerChange(
                                        i,
                                        'material',
                                        $event
                                    )
                                "
                            />
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].material
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .material.$invalid
                                "
                                class="error-label"
                            >
                                Поле необходимо заполнить
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-4 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label"
                                >Цвет</label
                            >
                            <select-picker
                                :current-value="insert.color"
                                :options="insertColors"
                                key-value="ColorID"
                                key-title="Name"
                                :classes="['select', 'select--product-form']"
                                :search="true"
                                @onChange="
                                    onInsertSelectPickerChange(
                                        i,
                                        'color',
                                        $event
                                    )
                                "
                            />
                        </div>
                    </div>

                    <div class="col-md-4 order-md-2 product-form-insert__col">
                        <div
                            class="cabinet-form-group cabinet-form-group--multiplie"
                        >
                            <label class="cabinet-form-group__label"
                                >Огранка | Количество граней</label
                            >
                            <div class="d-flex justify-content-between">
                                <div class="cabinet-form-group--select-wrap">
                                    <select-picker
                                        :current-value="insert.facet"
                                        :options="insertFacets"
                                        key-value="FacetID"
                                        key-title="Name"
                                        :classes="[
                                            'select',
                                            'select--product-form'
                                        ]"
                                        :search="true"
                                        @onChange="
                                            onInsertSelectPickerChange(
                                                i,
                                                'facet',
                                                $event
                                            )
                                        "
                                    />
                                </div>
                                <div
                                    class="cabinet-form-group--input-wrap cabinet-form-group--input-wrap--small"
                                >
                                    <input
                                        :id="'face_number' + i"
                                        v-model="insert.faceNumber"
                                        type="number"
                                        min="0"
                                        class="cabinet-form-group__input cabinet-form-group__input--icon cabinet-form-group__input--full"
                                        :class="{
                                            error:
                                                $v.product.inserts.$each.$iter[
                                                    i
                                                ].faceNumber.$dirty &&
                                                $v.product.inserts.$each.$iter[
                                                    i
                                                ].faceNumber.$invalid
                                        }"
                                    />

                                    <div
                                        v-if="
                                            $v.product.inserts.$each.$iter[i]
                                                .faceNumber.$dirty &&
                                                $v.product.inserts.$each.$iter[
                                                    i
                                                ].faceNumber.$invalid
                                        "
                                        class="error-label"
                                    >
                                        Введите число от 0 до 500
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-5 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label
                                class="cabinet-form-group__label"
                                for="clarity"
                                >Чистота вставки</label
                            >
                            <input
                                :id="'clarity' + i"
                                v-model="insert.clarity"
                                type="text"
                                class="cabinet-form-group__input"
                                :class="{
                                    error:
                                        $v.product.inserts.$each.$iter[i]
                                            .clarity.$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .clarity.$invalid
                                }"
                            />
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].clarity
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .clarity.$invalid
                                "
                                class="error-label"
                            >
                                Введите не более 5 символов
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-3 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label" for="carat"
                                >Общая каратность</label
                            >
                            <div class="cabinet-form-group--input-wrap">
                                <input
                                    :id="'carat' + i"
                                    v-model="insert.size"
                                    type="number"
                                    min="0"
                                    class="cabinet-form-group__input cabinet-form-group__input--icon"
                                    :class="{
                                        error:
                                            $v.product.inserts.$each.$iter[i]
                                                .size.$dirty &&
                                            $v.product.inserts.$each.$iter[i]
                                                .size.$invalid
                                    }"
                                />
                                <div class="cabinet-form-group__icon">crt</div>
                            </div>
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].size
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i].size
                                            .$invalid
                                "
                                class="error-label"
                            >
                                Введите число от 0 до 99999.999
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-6 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label" for="stone"
                                >Количество камней</label
                            >
                            <div class="cabinet-form-group--input-wrap">
                                <input
                                    :id="'stone' + i"
                                    v-model="insert.quantity"
                                    type="number"
                                    min="0"
                                    class="cabinet-form-group__input cabinet-form-group__input--icon"
                                    :class="{
                                        error:
                                            $v.product.inserts.$each.$iter[i]
                                                .quantity.$dirty &&
                                            $v.product.inserts.$each.$iter[i]
                                                .quantity.$invalid
                                    }"
                                />
                                <div class="cabinet-form-group__icon">шт</div>
                            </div>
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].quantity
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .quantity.$invalid
                                "
                                class="error-label"
                            >
                                Введите число от 0 до 1000
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /product-form-insert__block -->

            <div
                class="cabinet-form-group d-flex flex-column flex-md-row align-items-md-center"
            >
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default cabinet-btn--gray cabinet-btn--add cabinet-btn--big"
                    :disabled="product.inserts.length >= 100"
                    @click="addInsert()"
                >
                    Добавить вставку
                </button>
                <span
                    v-if="product.inserts.length >= 100"
                    class="pt-3 pt-md-0 pl-md-3"
                    >Вы добавили максимальное количество вставок.</span
                >
            </div>

            <div class="product-form__btn-wrap">
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :class="{ loading }"
                    :disabled="!product.id"
                    @click="saveProduct()"
                >
                    Сохранить изменения
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import TabsHeaderMobile from '@/components/Cabinet/Tabs/TabsHeaderMobile'
import SelectPicker from '@/components/Elements/SelectPicker'
import { mapState, mapGetters, mapActions } from 'vuex'

import { required, maxLength, between, integer } from 'vuelidate/lib/validators'

const validations = {
    product: {
        inserts: {
            $each: {
                material: { required },
                clarity: {
                    maxLength: maxLength(5)
                },
                size: {
                    between: between(0, 99999.999)
                },
                quantity: {
                    integer,
                    between: between(0, 1000)
                },
                faceNumber: {
                    integer,
                    between: between(0, 500)
                }
            }
        }
    }
}

export default {
    name: 'EditInserts',
    components: { TabsHeaderMobile, SelectPicker },
    data() {
        return {
            product: {
                id: '', //indicate product was loaded
                iteminsert: '',
                inserts: [
                    // {
                    //     material: '',
                    //     color: '',
                    //     facet: '',
                    //     clarity: '',
                    //     size: '',
                    //     quantity: ''
                    // }
                ]
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters('supplierProducts', ['getFormattedProduct']),

        ...mapState('insert', [
            'insertMaterials',
            'insertColors',
            'insertFacets'
        ])
    },
    validations,
    watch: {
        getFormattedProduct: {
            handler: function(val) {
                if (!this.product.id && Object.keys(val).length) {
                    this.setProductFields()
                }
            },
            deep: true
        }
    },
    mounted() {
        if (Object.keys(this.getFormattedProduct).length) {
            this.setProductFields()
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['updateProduct', 'getProduct']),
        setProductFields() {
            this.product = {
                ...this.getFormattedProduct
            }
        },
        onInsertSelectPickerChange(i, type, val) {
            this.product.inserts[i][type] = parseInt(val)
        },
        addInsert() {
            this.product.inserts.push({
                material: '',
                color: '',
                facet: '',
                faceNumber: '',
                clarity: '',
                size: '',
                quantity: ''
            })
        },
        removeInsert(i) {
            this.product.inserts.splice(i, 1)
        },
        async saveProduct() {
            if (this.loading) return

            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.loading = true

                let inserts = []

                if (this.product.inserts.length) {
                    inserts = this.product.inserts.map(item => {
                        return {
                            ItemInsertID: item.id || null,
                            MaterialID: item.material,
                            ColorID: item.color || undefined,
                            FacetID: item.facet || undefined,
                            Clarity: item.clarity,
                            Size: item.size ? parseFloat(item.size) : undefined,
                            Quantity: item.quantity
                                ? parseInt(item.quantity)
                                : undefined,
                            FaceNumber: item.faceNumber
                                ? parseInt(item.faceNumber)
                                : undefined
                        }
                    })
                }

                try {
                    let payload = {
                        id: this.product.id,
                        type: 'inserts',
                        data: {
                            ItemInsert: this.product.iteminsert,
                            Inserts: inserts
                        }
                    }
                    await this.updateProduct(payload)
                    this.clearSupplierCatalogFilterDict()

                    this.$notify({
                        title: 'Продукт успешно обновлен',
                        type: 'success'
                    })
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }

                try {
                    await this.getProduct(this.product.id)
                    this.setProductFields()
                } catch (e) {
                    console.log(e)
                }

                this.loading = false
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        }
    }
}
</script>
